import { Component, Input, OnInit } from '@angular/core';
import { IBreadcrumbItem } from 'src/app/interfaces/breadcrumb/breadcrumb.interface';

@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent implements OnInit {
    @Input() title: string;
    @Input() breadcrumbs: IBreadcrumbItem[];

    constructor() {}

    ngOnInit(): void {}
}
